export const FbIcon = () => (
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M38 19C38 28.646 30.8119 36.6131 21.5 37.837V25H25.5L26.5 19H21.5V15C21.5 12.3575 24.1225 12.4289 26.1862 12.485C26.4709 12.4927 26.7449 12.5002 27 12.5002V7.78148C26.6445 7.75289 26.2942 7.72205 25.949 7.69166C22.896 7.42285 20.2478 7.18969 18.0173 8.86804C16 10.3859 15.5 12.4396 15.5 15.0003V19H11V25H15.5V37.6783C6.67846 36.0356 0 28.2977 0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19Z"
      fill="#4676EE"
    />
    <path d="M18.9247 37.9999L19.0756 37.9999L19 38L18.9247 37.9999Z" fill="#4676EE" />
  </svg>
)
